import * as React from 'react';

function EmptyTSPIllustration(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={138} height={60} viewBox="0 0 138 60" {...props}>
      <title>CB526AF9-0FF5-4142-9584-FDD9033E7267</title>
      <g fill="none" fillRule="evenodd">
        <g transform="translate(75)">
          <rect stroke="#E1E1E1" fill="#FFF" x={0.5} y={0.5} width={62} height={59} rx={2} />
          <path d="M2 0h59a2 2 0 012 2v26H0V2a2 2 0 012-2z" fill="#BDBDBD" />
          <path fill="#FFF" d="M7 7h36.651v4.189H7z" />
          <path
            fill="#BDBDBD"
            d="M7 36h15.708v3.142H7zM7 43h19.896v3.142H7zM7 49h13.613v3.142H7zM33 36h15.708v3.142H33zM33 43h19.896v3.142H33z"
          />
          <path fill="#FFF" d="M7 16h26.179v4.189H7z" />
        </g>
        <g>
          <rect stroke="#E1E1E1" fill="#FFF" x={0.5} y={0.5} width={62} height={59} rx={2} />
          <path d="M2 0h59a2 2 0 012 2v26H0V2a2 2 0 012-2z" fill="#BDBDBD" />
          <path fill="#FFF" d="M7 7h36.651v4.189H7z" />
          <path
            fill="#BDBDBD"
            d="M7 36h15.708v3.142H7zM7 43h19.896v3.142H7zM7 49h13.613v3.142H7zM33 36h15.708v3.142H33zM33 43h19.896v3.142H33z"
          />
          <path fill="#FFF" d="M7 16h26.179v4.189H7z" />
        </g>
      </g>
    </svg>
  );
}

export default EmptyTSPIllustration;
